import * as React from "react";
import { forwardRef } from "react";
const SvgConnection = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 40, height: 10, viewBox: "0 0 40 10", fill: "none", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M9 5L31 5", stroke: "#0F1013", strokeDasharray: "2 2" }), /* @__PURE__ */ React.createElement("circle", { cx: 5, cy: 5, r: 3.5, stroke: "#0F1013", strokeWidth: 3 }), /* @__PURE__ */ React.createElement("circle", { cx: 35, cy: 5, r: 3.5, fill: "#0F1013", stroke: "#0F1013", strokeWidth: 3 }));
const ForwardRef = forwardRef(SvgConnection);
export default ForwardRef;
